import { IItemCache } from '../models/IItemCacheObserver';
import { IItemCacheThunkAction, IItemCacheDispatch } from '../store/actions/ItemCacheActions';
import { IItemCacheState } from '../store/reducers/itemCacheReducer';
import { getItemCacheEvaluator } from '../models/itemCache/ItemCacheEvaluator';
import { NO_CONTROL_HANDLERS } from '../models/controls/ControlFacet';

/**
 * @public
 */
export function readItems<T>(readDataFromItemCache: (itemCache: IItemCache) => T): IItemCacheThunkAction<T> {
  return (dispatch: IItemCacheDispatch, getState: () => IItemCacheState) => {
    const owner = {};

    const evaluator = dispatch(getItemCacheEvaluator);

    const {
      result
    } = evaluator.evaluate({
      selector: readDataFromItemCache,
      controlHandlers: NO_CONTROL_HANDLERS,
      state: getState(),
      suspender: owner,
      owner
    });

    return result;
  };
}
